const { DEV, VITE_ENVIRONMENT } = import.meta.env;

export const getApiHost = (): string => {
  if (DEV) {
    const { host } = window.location;
    return `${host}`;
  }
  if (VITE_ENVIRONMENT === 'staging') {
    return 'widget.volumental.dev';
  }
  return 'widget.volumental.com';
};

// getApiURL is a function that returns the api path based on the environment.
export const getApiURL = (): string => `https://${getApiHost()}/query`;

// getApiURL is a function that returns the api path based on the environment.
export const getWsApiURL = (): string => `wss://${getApiHost()}/query`;
